import script from "./LoadingSpinnerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingSpinnerComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoadingSpinnerComponent.vue?vue&type=style&index=0&id=3684ae7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3684ae7f"]])

export default __exports__